import { DSTItemType, GoogleItemType, PromaItemType } from './itemDefinitions';

export enum ViewFilterFields {
  selectRisk,
  selectBlock,
  selectSimSheet,
  selectKvPhase,
  selectValueType,
  selectRiskType,
  selectAllianceVsClient,
  cameraTime,
  viewTime,
  itemFilter
}

export enum DSTFieldType {
  username,
  title,
  parent,
  colorPicker,
  complete,
  startAndDue
}

interface BucketContents {
  fieldName: string;
  itemType: DSTItemType;
}

/** Define which general fields are to be shown on each item type */
export const DSTFields: { [key: string]: DSTFieldType[] } = {
  [DSTItemType.DstUser]: [DSTFieldType.username],
  [DSTItemType.TodoTask]: [
    DSTFieldType.title,
    DSTFieldType.parent,
    DSTFieldType.colorPicker,
    DSTFieldType.complete,
    DSTFieldType.startAndDue
  ],
  [DSTItemType.CoreBucket]: [
    DSTFieldType.title,
    DSTFieldType.parent,
    DSTFieldType.colorPicker,
    DSTFieldType.complete,
    DSTFieldType.startAndDue
  ],
  [DSTItemType.CoreTag]: [DSTFieldType.title, DSTFieldType.colorPicker],
  [DSTItemType.CoreIcon]: [],
  [DSTItemType.CoreLink]: [DSTFieldType.parent],
  [DSTItemType.TrackingHabit]: [DSTFieldType.title, DSTFieldType.parent, DSTFieldType.colorPicker],
  [DSTItemType.TrackingHabitTarget]: [],
  [DSTItemType.TrackingHabitLog]: []
};

export const titleField: {[key: string]: string} = {
  [DSTItemType.DstUser]: 'username',
  [GoogleItemType.Folder]: 'name',
  [PromaItemType.Block]: 'name',
  [PromaItemType.TeknAla]: 'name'
}

export const bucketContents: BucketContents[] = [
  {
    fieldName: 'todo_tasks',
    itemType: DSTItemType.TodoTask
  },
  {
    fieldName: 'children',
    itemType: DSTItemType.CoreBucket
  }
];
